import { jsx as _jsx } from "react/jsx-runtime";
import { Tooltip } from '@/components';
export var withTooltip = function (title, visible, jsx) {
    if (visible) {
        return (_jsx(Tooltip, { placement: 'top', title: title, children: _jsx("span", { children: jsx }) }));
    }
    return jsx;
};
